import React, { useEffect, useState } from 'react';
import './TreatmentDetailHero.scss';
import { getTreatmentBySlug } from '../../services/treatmentService';

const TreatmentDetailHero = ({ slug }) => {
    const [treatment, setTreatment] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTreatment = async () => {
            try {
                const data = await getTreatmentBySlug(slug);
                setTreatment(data);
            } catch (error) {
                console.error('Tedavi detayı yüklenirken hata:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchTreatment();
    }, [slug]);

    if (loading) {
        return (
            <section className="treatment-detail-hero">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Yükleniyor...</h1>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!treatment) {
        return (
            <section className="treatment-detail-hero">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Tedavi bulunamadı</h1>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    // heroImage'i öncelikli olarak kullan, yoksa image'e düş
    const heroImage = treatment.heroImage || treatment.image;

    return (
        <section className="treatment-detail-hero">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="hero-content">
                            <div className="hero-category">
                                {treatment.treatmentCategory?.name?.toUpperCase() || treatment.category?.toUpperCase()}
                            </div>
                            <h1 className="hero-title">
                                {treatment.title}
                            </h1>
                            <p className="hero-description">
                                {treatment.shortDesc}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="hero-image">
                            <img 
                                src={heroImage} 
                                alt={treatment.title}
                                onError={(e) => {
                                    if (!e.target.src.startsWith('data:')) {
                                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgdmlld0JveD0iMCAwIDYwMCA0MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2MDAiIGhlaWdodD0iNDAwIiBmaWxsPSIjZjhmOWZlIi8+CjxjaXJjbGUgY3g9IjMwMCIgY3k9IjIwMCIgcj0iNDAiIGZpbGw9IiMyMzJhNmMiIGZpbGwtb3BhY2l0eT0iMC4zIi8+CjxwYXRoIGQ9Ik0yODAgMTgwSDMyMFYyMjBIMjgwVjE4MFoiIGZpbGw9IiMyMzJhNmMiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=';
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TreatmentDetailHero; 